import React, { FC, Fragment } from 'react';
import styles from './applications.module.scss';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ChangesForm } from './changes-form';
import { useTranslate } from '@refinedev/core';
import { ICategory } from '../../../../interfaces';
import { buildKey } from '../../../../utils/accessory';
import { Button, Col, Divider, Form, Row, Space } from 'antd';
import { useSelect } from '@refinedev/antd';
import { DatePicker, FormItem, Input, Select, Textarea } from 'components/ui';
import cn from 'classnames';

const FIELD_KEY = 'applications';

export const Applications: FC = () => {
    const t = useTranslate();

    const { selectProps: typeProps } = useSelect<ICategory>({
        resource: 'dictionary/certificate-request-types',
        defaultValue: [],
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: 'server',
        },
    });

    return (
        <Row gutter={[16, 16]}>
            <Col className={styles.col} span={24}>
                <Form.List name={FIELD_KEY}>
                    {(fields, { add, remove }, { errors }) => {
                        return (
                            <div>
                                {fields?.length > 0 && (
                                    <Divider>
                                        {t('applications.fields.application')}
                                    </Divider>
                                )}
                                {fields?.map((field, index) => (
                                    <Fragment
                                        key={buildKey(FIELD_KEY, ++field.key)}
                                    >
                                        <Space
                                            align="start"
                                            className={cn(
                                                styles.holder,
                                                styles.applicationWrap
                                            )}
                                        >
                                            <Row gutter={[16, 16]}>
                                                <Col span={24}>
                                                    <FormItem
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'mohApplicationNumber',
                                                        ]}
                                                    >
                                                        <Input
                                                            label={t(
                                                                'applications.fields.moh_application_number'
                                                            )}
                                                        />
                                                    </FormItem>
                                                </Col>

                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'mohApplicationDate',
                                                        ]}
                                                    >
                                                        <DatePicker
                                                            label={t(
                                                                'applications.fields.moh_application_date'
                                                            )}
                                                            placeholder={t(
                                                                'applications.fields.select_date'
                                                            )}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={24}>
                                                    <FormItem
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'procedureNotes',
                                                        ]}
                                                    >
                                                        <Textarea
                                                            label={t(
                                                                'applications.fields.procedure_notes'
                                                            )}
                                                        />
                                                    </FormItem>
                                                </Col>

                                                <Col span={24}>
                                                    <Row
                                                        justify="end"
                                                        gutter={[16, 16]}
                                                    >
                                                        <Col>
                                                            <Button
                                                                type="text"
                                                                danger
                                                                icon={
                                                                    <MinusCircleOutlined />
                                                                }
                                                                onClick={() =>
                                                                    remove(
                                                                        field.name
                                                                    )
                                                                }
                                                                aria-label={t(
                                                                    'buttons.delete'
                                                                )}
                                                            >
                                                                {t(
                                                                    'buttons.delete'
                                                                )}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <FormItem
                                                        {...field}
                                                        name={[
                                                            field.name,
                                                            'typeId',
                                                        ]}
                                                    >
                                                        <Select
                                                            label={t(
                                                                'applications.fields.application_type'
                                                            )}
                                                            {...typeProps}
                                                        />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </Space>
                                        <Space
                                            align="start"
                                            className={styles.holder}
                                        >
                                            <Form.Item
                                                style={{
                                                    width: '100%',
                                                }}
                                            >
                                                <ChangesForm
                                                    fieldKey={field.name}
                                                />
                                            </Form.Item>
                                        </Space>
                                    </Fragment>
                                ))}
                                {fields?.length > 0 && (
                                    <Divider style={{ margin: '16px 0' }} />
                                )}
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    block
                                    style={{ marginBottom: 20 }}
                                >
                                    <PlusOutlined />{' '}
                                    {t('applications.fields.add_application')}
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </div>
                        );
                    }}
                </Form.List>
            </Col>
        </Row>
    );
};
